module.exports = __webpack_public_path__ + "static/media/image_18.8d5c3b65.png";